import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAllAutomationTemplatesQueries } from '../Automation/queries/useAutomationTemplatesQuery';

export const useDeleteAutomationTemplateMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IAutomationTemplateReference) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ id, impersonationContext }: { id: string; impersonationContext?: Api.IImpersonationContext }) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplateReference>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `automationTemplate/${id}`,
					impersonationContext,
				}),
				'DELETE',
				null
			);
		},
		onError,
		onSuccess: data => {
			invalidateAllAutomationTemplatesQueries();
			onSuccess?.(data);
		},
	});
};
